import { render, staticRenderFns } from "./StockcountPage.vue?vue&type=template&id=667e4443"
import script from "./StockcountPage.vue?vue&type=script&lang=js"
export * from "./StockcountPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports